import { Component } from '@angular/core';

@Component({
  selector: 'lib-page-footer',
  imports: [],
  templateUrl: './page-footer.html',
  styleUrl: './page-footer.css',
})
export class PageFooter {

}
